export const selectDivision = (state) => state.division && state.division.data;
